module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading personal-account-header\">\r\n    <div class=\"col-lg-12\">\r\n        <h2>Bid Management</h2>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"help-bid-management-page personal-account-page\">\r\n    <div class=\"help-content-scroll help-content-body\" [innerHTML]=\"content\"></div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/account.management/help/help.bid-management.component.html
// module id = 1158
// module chunks = 0